import _ from 'lodash'
import core from '../../core'

import { valueTable as commonConfigValues } from './commonConfig'

const { theirRole, decision } = commonConfigValues

const { helpers: { keepInLength, getUserId, getLoginFromMail } } = core

const styles = {
  floatingLabel: { fontSize: '1.1rem' },
  fieldText: { fontSize: '0.8rem' }
}

export const adviceDecision = [
  { id: 1, label: 'Advice Accepted' },
  { id: 2, label: 'Advice Under Consideration' },
  { id: 3, label: 'Advice Not Accepted' }
]

export const valueTable = {
  adviceDecision
}

export const views = [
  {
    id: 1,
    viewName: 'QuickView',
    columns: [
      'person.fullName',
      'advice.date',
      'advice.adviceReceived',
      'advice.theirRoleReceived',
      'advicMade',
      'advicLogged',
      'advice.notes'
    ]
  }
]

export const columns = [
  {
    name: 'id',
    title: 'ID',
    hidden: true,
    formField: true
  },
  {
    name: 'register.personId',
    title: 'YP UI',
    minSpace: 'YP UIw ',
    formField: true
  },
  {
    name: 'register.person.firstName',
    title: 'YP First Name',
    hidden: true,
    minSpace: 'YP ',
    formField: true
  },
  {
    name: 'register.person.lastName',
    title: 'YP Last Name',
    hidden: true,
    minSpace: 'YP ',
    formField: true
  },
  {
    name: 'register.person.fullName',
    title: 'YP Name',
    formField: true,
    getCellValue: row =>
      `${row['register.person.firstName']} ${row['register.person.lastName']}`,
    maxChars: 100,
    minSpace: 'YP Name '
  },
  {
    name: 'advice.date',
    title: 'Advice Received Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Advice Received '
  },
  {
    name: 'advice.time',
    title: 'Advice Received Time',
    formField: true,
    type: 'time',
    filterField: true,
    minSpace: 'Advice Received '
  },
  {
    name: 'advice.adviceReceived',
    title: 'Advice Received From Name(s)',
    formField: true,
    maxChars: 50,
    minSpace: 'Advice Received From '
  },
  {
    name: 'advice.theirRoleReceived',
    title: 'Their Role(s)',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(theirRole, ['id', parseInt(row[`advice.theirRoleReceived`], 10)])
        ? _.find(theirRole, [
            'id',
            parseInt(row[`advice.theirRoleReceived`], 10)
          ]).label
        : row[`advice.theirRoleReceived`],
    options: 'theirRole',
    filterField: true,
    minSpace: 'Their Role(s) '
  },
  {
    name: 'advice.adviceGiven',
    title: 'Advice Given To Name(s)',
    formField: true,
    maxChars: 50,
    minSpace: 'Advice Given To '
  },
  {
    name: 'advice.theirRoleGiven',
    title: 'Their Role(s)',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(theirRole, ['id', parseInt(row[`advice.theirRoleGiven`], 10)])
        ? _.find(theirRole, ['id', parseInt(row[`advice.theirRoleGiven`], 10)])
            .label
        : row[`advice.theirRoleGiven`],
    options: 'theirRole',
    filterField: true,
    minSpace: 'Their Role(s) '
  },
  {
    name: 'advice.notes',
    title: 'Advice Notes ',
    formField: true,
    maxChars: 500,
    filterField: true,
    minSpace: 'Advice Notes '
  },
  {
    name: 'advice.evidenced',
    title: 'Advice Evidenced',
    formField: true,
    maxChars: 100,
    filterField: true,
    minSpace: 'Evidenced '
  },
  {
    name: 'advice.decisionMade',
    title: 'Decision(s) Made?',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(adviceDecision, ['id', parseInt(row[`advice.decisionMade`], 10)])
        ? _.find(adviceDecision, [
            'id',
            parseInt(row[`advice.decisionMade`], 10)
          ]).label
        : row[`advice.decisionMade`],
    options: 'adviceDecision',
    filterField: true,
    minSpace: 'Decision(s) '
  },
  {
    name: 'advice.decisionLogged',
    title: 'Decision(s) Logged?',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(decision, ['id', parseInt(row[`advice.decisionLogged`], 10)])
        ? _.find(decision, ['id', parseInt(row[`advice.decisionLogged`], 10)])
            .label
        : row[`advice.decisionLogged`],
    options: 'decision',
    filterField: true,
    minSpace: 'Decision(s) '
  }
]

export const getSubForms = ({
  data: { centres, persons, reasons },
  fields,
  change,
  formName,
  showAsterix,
  openToYearSelection,
  hideCalendarDate,
  disabled,
  add,
  formValues,
  proceedSelectionChange,
  personAdd,
  availableValues
}) => {
  const forms = [
    {
      id: 1,
      name: 'reg',
      activeName: 'advice',
      historyName: 'adviceHistory',
      label: 'Register',
      icon: 'note',
      fields: [
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'registerId',
          disabled: !add,
          label: 'Register Entry',
          required: showAsterix,
          validate: v => (v ? undefined : 'Field is required'),
          options: availableValues.register.filter(f => f.id > 0).map(o => {
            const person = _.find(availableValues.persons, ['id', o.personId])
            const label = `${person.firstName} ${person.lastName} (register: ${
              o.id
            })`
            return { value: o.id, label: label }
          })
        }
      ]
    },
    {
      id: 2,
      name: 'adv',
      activeName: 'advice',
      historyName: 'adviceHistory',
      label: 'Professional Advice',
      icon: 'note',
      fields: [
        [
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'advice.date',
            label: 'Advice Received Date',
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.timepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'advice.time',
            label: 'Advice Received Time',
            required: showAsterix,
            minutesStep: 1,
            // openToYearSelection: openToYearSelection,
            //hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v => (v ? undefined : 'Field is required')
          }
        ],
        [
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            required: showAsterix,
            name: 'advice.adviceReceived',
            label: 'Advice Received From Name(s)',
            normalize: v => {
              const val = keepInLength(v, 50)
              return val
            },
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'advice.theirRoleReceived',
            label: 'Their Role(s)',
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: availableValues.theirRole.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          }
        ],
        [
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            required: showAsterix,
            name: 'advice.adviceGiven',
            label: 'Advice Given To Name(s)',
            normalize: v => {
              const val = keepInLength(v, 50)
              return val
            },
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'advice.theirRoleGiven',
            label: 'Their Role(s)',
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: availableValues.theirRole.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          }
        ],
        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          rows: 1,
          maxRows: 10,
          required: showAsterix,
          name: 'advice.notes',
          label: 'Advice Notes',
          normalize: v => {
            const val = keepInLength(v, 500)
            return val
          },
          validate: v => (v ? undefined : 'Field is required')
        },
        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          required: showAsterix,
          name: 'advice.evidenced',
          label: 'Advice Evidenced',
          normalize: v => {
            const val = keepInLength(v, 100)
            return val
          },
          validate: v => (v ? undefined : 'Field is required')
        },
        [
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'advice.decisionMade',
            label: 'Decision(s) Made?',
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: availableValues.adviceDecision
              .filter(f => f.id > 0)
              .map(o => {
                return { value: o.id, label: o.label }
              })
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'advice.decisionLogged',
            label: 'Decision(s) Logged?',
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: availableValues.decision.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          }
        ]
      ]
    }
  ]

  return forms
}

export const activeSection = ['advice']

export const errors = [1, 2]

export const defaultNew = {
  advice: {
    historyId: 'new',
    audit: {
      active: true,
      modifiedBy: getLoginFromMail(getUserId()),
      modifiedDate: new Date()
    }
  },
  adviceHistory: []
}

// "advices": [
//   {
// "advice": {
//   "id": 1,
//   "registerId": 1, //  ->  "personId": 2 -> person,
//   "date": "2001-01-01T23:28:56.782Z",
//   "time": "T23:28:56.782Z",
//   "adviceReceived": "ddd",
//   "theirRoleReceived": 2,
//   "adviceGiven": "ddd",
//   "theirRoleGiven": 2,
//   "notes": "aaa"
//   "evidenced" : 2,
//   "decisionMade" :2,
//   "decisionLogged": 1,
// },
// "adviceHistory": {

// }
//   }
// ]



// WEBPACK FOOTER //
// ./src/register/configs/professionalAdvices.js